import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

// Attach bearer token if available (fallback for environments where cookies misbehave)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('fs_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || 'Algo salió mal. Intenta de nuevo.';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
    }
    if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
}

export default api;
